<template>
<ul
    :class="$style.list"
    @click="onClick">
    <li>
        <m-button
            :trailing-icon="`arrow_drop_${isGuideOpen ? 'up' : 'down'}`"
            :label="$t(`page.guide`)"
            :class="$style.parent"
            @click.native="isGuideOpen = !isGuideOpen" />
        <guide-sidebar v-if="isGuideOpen" />
    </li>
    <li>
        <template v-if="hasProject">
            <m-button
                :trailing-icon="`arrow_drop_${
                    isApplicationOpen ? 'up' : 'down'
                }`"
                :label="$t(`page.project`)"
                :class="$style.parent"
                @click.native="isApplicationOpen = !isApplicationOpen" />
            <developer-sidebar v-if="isApplicationOpen" />
        </template>
    </li>
    <li>
        <a
            :class="$style.parent"
            :href="whale_lab"
            target="_blank">{{
                $t("whale_lab.title")
            }}</a>
    </li>
    <li>
        <a
            :class="$style.parent"
            :href="homepage_notices"
            target="_blank">{{ $t("notices.title") }}</a>
    </li>
</ul>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import GuideSidebar from "@/components/guide/GuideSidebar.vue";
import DeveloperSidebar from "@/components/developer/DeveloperSidebar.vue";
import mButton from "@/components/mdc/Button.vue";
import { DEVELOPER_PROJECTS } from "@/router/path";
import { whale_lab, homepage_notices } from "@/data/links";

export default {
    components: { GuideSidebar, DeveloperSidebar, mButton },
    data: () => ({
        whale_lab,
        homepage_notices,
        DEVELOPER_PROJECTS,
        isGuideOpen: false,
        isApplicationOpen: true
    }),
    computed: mapGetters(["hasProject"]),
    methods: {
        ...mapMutations(["SET_SIDEBAR_OPEN"]),
        onClick({ target: { tagName } }) {
            if (tagName === "A") this.SET_SIDEBAR_OPEN(false);
        }
    }
};
</script>

<style lang="scss" module>
@use "@material/typography/typography";
@use "@material/button";

.list {
    padding: 0 0 80px 30px;
    width: 255px;
    height: calc(100% - 60px);
    overflow: auto;
    aside {
        border-right: 0;
        width: fit-content;
        min-width: 100%;
    }
    ul {
        padding: 0;
    }
    > li {
        border-bottom: 1px solid #dde2e580;
    }
    .parent {
        & + aside {
            border-top: 1px solid #dde2e580;
        }
        font-size: typography.px-to-rem(16px);
        min-height: 60px;
        color: #121212;
        font-weight: bold;
    }
    a {
        display: flex;
        align-items: center;
        padding-left: 0;
        color: #000;
        &:hover {
            color: #1177ef;
            background-color: white;
        }
        &:global(.router-link-active) {
            color: #1177ef;
            background-color: white;
            font-weight: bold;
        }
    }
    :global {
        .mdc-button {
            @include button.ink-color(
                (
                    default: #121212,
                    hover: #1177ef
                )
            );
            justify-content: space-between;
            width: 100%;
            padding: 0 20px 0 0;
            svg {
                width: 12px;
                height: 12px;
            }
        }
        .mdc-drawer__content {
            overflow-y: unset;
        }
        .mdc-button__ripple::before,
        .mdc-button__ripple::after {
            background-color: white !important;
        }
    }
}
</style>
